import './customSelect.style.scss'
import Select, { GroupBase, SingleValue } from 'react-select'

export type SelectOption = {
  label: string
  value: string
}

export type CustomSelectProps<Option extends SelectOption = SelectOption> = {
  placeholder?: string
  id?: string
  data?: Option[]
  onChange?: (value: SingleValue<Option>) => void
  value?: SingleValue<Option>
  error?: string
}

function CustomSelect<Option extends SelectOption = SelectOption>({
  placeholder = 'Select',
  id,
  data = [],
  onChange,
  value,
  error,
}: CustomSelectProps<Option>) {
  return (
    <>
      <Select<Option, false, GroupBase<Option>>
        options={data}
        placeholder={placeholder}
        onChange={onChange}
        value={value != null ? value : null}
        id={id}
        styles={{
          control: (provided) => ({
            ...provided,
            width: '100%',
            height: '45px',
            borderRadius: 8,
            border: '1px solid var(--gray-300)',
            background: 'var(--white)',
            margin: 2,
            outline: 'none',
            color: 'var(--gray-300)',
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '14px',
            position: 'relative',
          }),
        }}
      />

      {error && (
        <p
          style={{
            marginTop: -5,
          }}
          className='error_message'
        >
          {error}
        </p>
      )}
    </>
  )
}

export default CustomSelect
